import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/utils';

export default function LanguageSelector() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-0.5 px-2 py-1 rounded-lg bg-black/20">
      <button
        onClick={() => setLanguage('nl')}
        className={cn(
          'px-2 py-1 rounded text-lg transition-all',
          language === 'nl' ? 'opacity-100 scale-110' : 'opacity-50 hover:opacity-75',
        )}
        title="Nederlands"
      >
        🇳🇱
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={cn(
          'px-2 py-1 rounded text-lg transition-all',
          language === 'en' ? 'opacity-100 scale-110' : 'opacity-50 hover:opacity-75',
        )}
        title="English"
      >
        🇬🇧
      </button>
    </div>
  );
}
